export const RIGHTSHOLDER_VALIDATION_STATUSES = {
    NOT_VALIDATED: {
        id: 1,
        name: 'Not Validated',
    },
    TRULIOO_PASSED: {
        id: 2,
        name: 'Trulioo Passed',
    },
    TROLIOO_FAILED: {
        id: 3,
        name: 'Trulioo Failed',
    },
    HFA_APPROVED_EXISTING: {
        id: 4,
        name: 'HFA Approved and Existing',
    },
    HFA_REJECTED: {
        id: 5,
        name: 'HFA Rejected',
    },
    HFA_COPIED: {
        id: 6,
        name: 'HFA Copied',
    },
    DONE: {
        id: 7,
        name: 'Done',
    },
    HFA_APPROVED_NEW: {
        id: 8,
        name: 'HFA Approved and New',
    },
    HFA_REJECTED_SUB: {
        id: 9,
        name: 'HFA Rejected Sub-Publisher',
    },
}

export const RIGHTSHOLDER_GROUP = {
    all: 'all',
    allDone: 'allDone',
    allPending: 'allPending',
    done: 'done',
    pending: 'pending',
    failed: 'failed',
}

export const RIGHTSHOLDER_VALIDATION_GROUP_STATUSES = {
    all: [],
    done: [RIGHTSHOLDER_VALIDATION_STATUSES.DONE.id],
    pending: [
        RIGHTSHOLDER_VALIDATION_STATUSES.NOT_VALIDATED.id,
        RIGHTSHOLDER_VALIDATION_STATUSES.TRULIOO_PASSED.id,
        RIGHTSHOLDER_VALIDATION_STATUSES.HFA_APPROVED_EXISTING.id,
        RIGHTSHOLDER_VALIDATION_STATUSES.HFA_APPROVED_NEW.id,
    ],
    failed: [
        RIGHTSHOLDER_VALIDATION_STATUSES.TROLIOO_FAILED.id,
        RIGHTSHOLDER_VALIDATION_STATUSES.HFA_REJECTED.id,
        RIGHTSHOLDER_VALIDATION_STATUSES.HFA_REJECTED_SUB.id,
    ],
}
